import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=aed2efc8&scoped=true"
import script from "./PopupModal.vue?vue&type=script&lang=js"
export * from "./PopupModal.vue?vue&type=script&lang=js"
import style0 from "./PopupModal.vue?vue&type=style&index=0&id=aed2efc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed2efc8",
  null
  
)

export default component.exports